/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import {LogoutActionFail, LogoutActionInProgress, LogoutActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function LogoutActionCreator
 * @param {}
 * @return {Promise<any>}  Promise
 */
export function LogoutActionCreator(): (dispatch: Dispatch<any>, {}) =>
    Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(LogoutActionInProgress());

    try {
      dispatch(LogoutActionSuccess());
    } catch (error) {
      dispatch(LogoutActionFail(error));
    }
  }
}


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/logout/index.ts